import React from "react";
import { Box } from "@mui/material";
import RemoveShoppingCartOutlinedIcon from "@mui/icons-material/RemoveShoppingCartOutlined";
import { useTranslation } from "react-i18next";
import RmfDialog, { DialogActions, DialogIcon, DialogText, DialogTitle, dialogButtonSx } from "../../Dialog/RmfDialog";

function ClearCart({ isVisible, toggleModal, action }) {
  const { t } = useTranslation();
  return (
    <RmfDialog open={isVisible} onClose={toggleModal}>
      <DialogIcon tone="red" sx={{ mb: 2.5 }}>
        <RemoveShoppingCartOutlinedIcon />
      </DialogIcon>
      <DialogTitle besideClose={false}>{t("areYouSure")}</DialogTitle>
      <DialogText>{t("clearCartText")}</DialogText>
      <DialogActions>
        <Box
          component="button"
          type="button"
          sx={dialogButtonSx.primary}
          onClick={async (e) => {
            e.preventDefault();
            await action();
            toggleModal();
          }}
        >
          {t("ok")}
        </Box>
        <Box component="button" type="button" sx={dialogButtonSx.secondary} onClick={toggleModal}>
          {t("cancel")}
        </Box>
      </DialogActions>
    </RmfDialog>
  );
}

export default React.memo(ClearCart);
